/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Snadné vracení`
};

const da_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Nem retur`
};

const de_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Einfache Rückgabe`
};

const en_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Easy returns`
};

const es_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Devoluciones fáciles`
};

const fr_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Retours facile`
};

const hu_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Könnyű visszaküldés`
};

const it_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Reso facile`
};

const nl_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Gemakkelijk retourneren`
};

const pl_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Łatwe zwroty`
};

const pt_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Devoluções fáceis`
};

const sv_reinsurances_easy_returns = /** @type {(inputs: {}) => string} */ () => {
	return `Enkla returer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_easy_returns = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_easy_returns(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_easy_returns", locale)
	if (locale === "cs") return cs_reinsurances_easy_returns(inputs)
	if (locale === "da") return da_reinsurances_easy_returns(inputs)
	if (locale === "de") return de_reinsurances_easy_returns(inputs)
	if (locale === "en") return en_reinsurances_easy_returns(inputs)
	if (locale === "es") return es_reinsurances_easy_returns(inputs)
	if (locale === "fr") return fr_reinsurances_easy_returns(inputs)
	if (locale === "hu") return hu_reinsurances_easy_returns(inputs)
	if (locale === "it") return it_reinsurances_easy_returns(inputs)
	if (locale === "nl") return nl_reinsurances_easy_returns(inputs)
	if (locale === "pl") return pl_reinsurances_easy_returns(inputs)
	if (locale === "pt") return pt_reinsurances_easy_returns(inputs)
	return sv_reinsurances_easy_returns(inputs)
};
export { reinsurances_easy_returns as "reinsurances.easy_returns" }